export default __webpack_public_path__ + "static/media/gallery19.4c0977ed.jpg";